import { useMutation } from "react-query";
import { PartnerApi } from "../../api/partner.api";
import { useSoldSNStore } from "../../store/soldsn.store";

export const useCompanies = () => {
  const setCompanies = useSoldSNStore((state) => state.setCompanies);

  return useMutation(PartnerApi.soldSNCompanies, {
    onSuccess: (data) => {
      setCompanies(data);
    },
    onError: (error) => {
      console.error("Login failed:", error);
    },
  });
};
